export default "__VITE_ASSET__CLyvKixk__"